import {
    faTimes,
} from '@fortawesome/free-solid-svg-icons';
import Header from 'Components/Layouts/Auth/Header';
import React from 'react';
import { DateTime } from 'luxon';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faExpandArrowsAlt} from '@fortawesome/pro-duotone-svg-icons';
import {faExpandWide} from '@fortawesome/pro-regular-svg-icons';
import {Link} from 'react-router-dom';
import { Event, User } from 'Services';

import CountDown from 'Components/CountDown';
import { asset } from 'Services/BaseHelpers';
import {resourceDateIsAfterNow, resourceDateIsBeforeNow} from 'Services/DateHelpers';
import release from 'Config/release';
import { Info } from "Components/Partials";
import Accommodation from "Pages/Cms/Elements/Accommodation";

export default class Dashboard extends React.Component {
    /** @type {HTMLDivElement} */
    pannable = null;
    locationSet = false;
    imageWidth = 3840;
    imageHeight = 2160;

    streamTimes = {
        'ASPAC': {
            countdown: {
                iso_string: '2022-04-26T08:00Z',
            },
            primary_unlock: {
                iso_string: '2022-04-26T08:00Z',
            },
            secondary_unlock: {
                iso_string: '2022-04-26T08:00Z',
            },
        },
        'EMEA': {
            countdown: {
                iso_string: '2022-04-26T08:00Z',
            },
            primary_unlock: {
                iso_string: '2022-04-26T08:00Z',
            },
            secondary_unlock: {
                iso_string: '2022-04-26T08:00Z',
            },
        },
        'AMERICAS': {
            countdown: {
                iso_string: '2022-04-26T08:00Z',
            },
            primary_unlock: {
                iso_string: '2022-04-26T08:00Z',
            },
            secondary_unlock: {
                iso_string: '2022-04-26T08:00Z',
            },
        },
        'Virtual': {
        countdown: {
            iso_string: '2022-04-26T08:00Z',
        },
        primary_unlock: {
            iso_string: '2022-04-26T08:00Z',
        },
        secondary_unlock: {
            iso_string: '2022-04-26T08:00Z',
        },
    },
    };

    state = {
        scale: 1,
        indicateScroll: false,
        labelFontSize: '30px',
        rollover: {
            visible: false,
            top: null,
            left: null,
            title: null,
            content: null,
            link: null,
        },
        showMenu: false,
        popup: null,
        onDemandShow: false,
        brandMarketingShow: false,
        countdown: this.streamTimes[User.data.timezone] ?? null,
    };

    popup = {
        main_stage: {
            locked: false,
            title: 'Main Stage',
            description: 'Coming soon',
            link: '/main-stage',
        },
        product_showcase: {
            locked: false,
            description: 'Coming soon',
            title: 'Product Showcase',
            link: '/product-showcase',
        },
        treehouse: {
            title: 'The Treehouse',
            link: '/the-treehouse',
        },
        on_demand: {
            title: 'On Demand',
            link: '/on-demand',
        },
        celebration_wall: {
            title: 'Gallery',
            link: '/celebration-wall',
        },
        profile: {
            title: 'Profile',
            link: '/settings/profile',
        },
        networking: {
            title: 'Networking',
            link: '/networking',
        },
        helpful_info: {
            title: 'FAQs',
            link: '/faq',
        },
        agenda: {
            title: 'Agenda',
            link: '/agenda',
        },
        brand_marketing: {
            title: 'Brand Marketing',
            link: '/brand-marketing'
        },
        faqs: {
            title: 'FAQs',
            link: '/faq'
        },
    }

    /**
     * @method handleToggleShowMenu
     */
    handleToggleShowMenu = () => {
        this.setState({
            showMenu: !this.state.showMenu,
        });
    };

    /**
     * @method handleToggleShowMenu
     */
    togglePopup = (popup) => {
        let distance = 0;
        if (this.original) {
            distance += Math.abs(this.original.x - this.pannable.scrollLeft);
            distance += Math.abs(this.original.y - this.pannable.scrollTop);
        }

        const info = this.popup[popup ?? 'main_stage'];

        if (info.locked) {
            return this.setState({
                popup,
            });
        }

        if (distance <= 50) {
            this.props.history.push(info.link);
        }
    };

    componentDidMount = async () => {
        this.updatedDimensions();
        window.addEventListener('resize', this.updatedDimensions);

        this.setPannable();
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.updatedDimensions);
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }

    updateTimeOfDay = () => {
        const hour = DateTime.now().hour;

        this.setState({
            background: hour >= 19 ? 'evening' : hour >= 17 ? 'sunset' : 'day',
        });
    }

    updatedDimensions = () => {
        // Dy default Set the scale to match the page width to the screen width.
        let fillPageWidth = true;
        const scale = (window.innerWidth / this.imageWidth);
        const labelFontSize = (30 * scale) + 'px';

        // If smaller screen then make pannable.
        if (window.innerWidth <= 1550) {
            fillPageWidth = false;
        }

        // If there's going to be lots of empty space at the bottom
        // of the page then make pannable.
        if ((this.imageHeight * scale) < (window.innerHeight * 10 / 12)) {
            fillPageWidth = false;
        }

        if (fillPageWidth === false) {
            this.setState({
                scale: window.innerHeight > 500 ? 0.5 : 0.3,
                labelFontSize: '30px',
                indicateScroll: true,
            });

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.setState({
                    indicateScroll: false,
                });
                this.timeout = null;
            }, 2500);
        } else {
            this.setState({
                scale,
                labelFontSize,
                indicateScroll: false,
            });
        }
    }
    /**
     * @method handleToggleShow
     */
    handleToggleShows = (page) => {
        Event.emit('content-open');

        this.setState({
            [page]: !this.state[page],
        }, () => null );
    }
    setPannable = () => {
        let panArea = this.pannable;

        let panning = false;
        let panFrom = {
            x: 0,
            y: 0,
        };
        this.original = null;

        panArea?.addEventListener('mousedown', e => {
            panning = true;
            panFrom = {
                x: e.clientX,
                y: e.clientY,
            };
            this.original = {
                x: panArea.scrollLeft,
                y: panArea.scrollTop,
            };

            e.preventDefault();
        });

        document.onmouseup = () => {
            panning = false;

            setTimeout(() => {
                this.original = null;
            }, 10);
        };

        panArea?.addEventListener('mousemove', e => {
            if (!panning) return;

            if (typeof panArea?.scrollBy === 'function') {
                panArea?.scrollBy(panFrom.x - e.clientX, panFrom.y - e.clientY);
            } else {
                panArea.scrollLeft = panArea.scrollLeft + (panFrom.x - e.clientX);
                panArea.scrollTop = panArea.scrollTop + (panFrom.y - e.clientY);
            }

            panFrom = {
                x: e.clientX,
                y: e.clientY,
            };
        });

        panArea.onscroll = () => {
            this.setState({
                scrollLeft: panArea.scrollLeft,
                scrollTop: panArea.scrollTop,
            });
        };

        this.setState({
            scrollLeft: panArea.scrollLeft,
            scrollTop: panArea.scrollTop,
        });

        this.timeout = setTimeout(() => {
            this.setState({
                indicateScroll: false,
            });
            this.timeout = null;
        }, 1500);
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {
            scale,
            countdown,
            brandMarketingShow,
            onDemandShow
        } = this.state;

        return (
            <div className="relative w-screen h-screen overflow-auto" style={{
                scrollBehaviour: 'smooth',
                paddingTop: 120,
            }} ref={ref => {
                this.pannable = ref;
                this.locationSet = true;
            }}>
                <div className="fixed top-0 left-0 right-0 z-10">
                    <Header/>
                </div>

                {countdown !== null && resourceDateIsAfterNow(countdown.countdown) && (
                    <div className="absolute top-52 right-10">
                        <CountDown startTime={countdown.countdown.iso_string}/>
                    </div>
                )}

                <img alt="" src={asset('/images/map/map.jpg?v=2')} className="max-w-none" style={{
                    width: this.imageWidth * scale,
                    height: this.imageHeight * scale,
                }}/>

                {this.state.indicateScroll && <div
                    className="flex fixed bg-app-banner rounded-md shadow-md z-20" style={{
                    width: 150,
                    height: 125,
                    top: 'calc(50% - 62.5px)',
                    left: 'calc(50% - 75px)',
                }}>
                       <span className="fa-layers fa-fw w-full m-auto">
                         <FontAwesomeIcon color="white" icon={faExpandWide} size="6x"/>
                         <FontAwesomeIcon color="white" icon={faExpandArrowsAlt} size="3x"/>
                       </span>
                </div>}

                <div className="absolute overflow-hidden inset-0" style={{
                    width: this.imageWidth * scale,
                    height: this.imageHeight * scale,
                    marginTop: 60,
                }}>
                    <div className="relative">
                         {/*Product showcase*/}
                        <div className="group cursor-pointer" onClick={() => this.togglePopup('product_showcase')}>
                            <div className="absolute cursor-pointer" style={{
                                top: 950 * scale,
                                left: 30 * scale,
                                width: 800 * scale,
                                height: 500 * scale,
                                transform: 'rotate(149deg)',
                            }}/>

                            <div
                                className="group-hover:scale-125 transform-gpu transition duration-300 text-2xl absolute"
                                style={{
                                    top: 1332 * scale,
                                    left: 194 * scale,
                                }}>
                                <img style={{width: 280 * scale}} src={asset('/images/map/product-showcase.png')}/>
                            </div>
                        </div>

                        {/*/!* On demand *!/*/}
                        <div className="group cursor-pointer" onClick={() => this.togglePopup('celebration_wall')}>
                            <div
                                className="absolute cursor-pointer"
                                style={{
                                    top: 500 * scale,
                                    left: 800 * scale,
                                    width: 600 * scale,
                                    height: 600 * scale,
                                    transform: 'rotate(135deg)',
                                    }}/>
                                <div
                                    className="group-hover:scale-125 transform-gpu transition duration-300 text-2xl absolute"
                                    style={{
                                        top: 935 * scale,
                                        left: 1210 * scale,
                                    }} >
                                <img style={{width: 250 * scale}} src={asset('/images/map/on-demand.png')}/>
                            </div>
                        </div>

                        {/* my profile */}
                        <div className="group cursor-pointer" onClick={() => this.togglePopup('faqs')}>
                            <div className="absolute cursor-pointer" style={{
                                top: 850 * scale,
                                left: 2025 * scale,
                                width: 500 * scale,
                                height: 500 * scale,
                                transform: 'rotate(130deg)',
                            }}/>

                            <div
                                className="group-hover:scale-125 transform-gpu transition duration-300 text-2xl absolute"
                                style={{
                                    top: 1097 * scale,
                                    left: 2380 * scale,
                                }}>
                                <img style={{width: 170 * scale}} src={asset('/images/map/faq.png')}/>
                            </div>
                        </div>

                         {/*main stage*/}
                        <div className="group cursor-pointer" onClick={() => this.togglePopup('main_stage')}>
                            <div className="absolute cursor-pointer" style={{
                                top: 1010 * scale,
                                left: 1050 * scale,
                                width: 950 * scale,
                                height: 715 * scale,
                                transform: 'rotate(140deg)',
                            }}/>

                            <div
                                className="group-hover:scale-125 transform-gpu transition duration-300 text-2xl absolute"
                                style={{
                                    top: 1528 * scale,
                                    left: 1668 * scale,
                                }}>
                                <img style={{width: 300 * scale}} src={asset('/images/map/main-stage.png')}/>
                            </div>
                        </div>

                        {/* Networking */}
                        <div className="group cursor-pointer" onClick={() => this.togglePopup('networking')}>
                            <div className="absolute cursor-pointer" style={{
                                top: 1580 * scale,
                                left: 140 * scale,
                                width: 950 * scale,
                                height: 520 * scale,
                                transform: 'rotate(160deg)',
                            }}/>

                            <div
                                className="group-hover:scale-125 transform-gpu transition duration-300 text-2xl absolute"
                                style={{
                                    top: 1946 * scale,
                                    left: 816 * scale,
                                }}>
                                <img style={{width: 300 * scale}} src={asset('/images/map/networking.png')}/>
                            </div>
                        </div>

                        {/* Agenda */}
                        <div className="group cursor-pointer" onClick={() => this.togglePopup('agenda')}>
                            <div className="absolute cursor-pointer" style={{
                                top: 1650 * scale,
                                left: 1720 * scale,
                                width: 550 * scale,
                                height: 545 * scale,
                                transform: 'rotate(135deg)',
                            }}/>

                            <div
                                className="group-hover:scale-125 transform-gpu transition duration-300 text-2xl absolute"
                                style={{
                                    top: 1992 * scale,
                                    left: 1690 * scale,
                                }}>
                                <img style={{width: 270 * scale}} src={asset('/images/map/agenda.png')}/>
                            </div>
                        </div>

                         {/*brand marketing*/}
                        <div className="group cursor-pointer" onClick={() => this.togglePopup('profile')}>
                            <div
                                className="absolute cursor-pointer"
                                style={{
                                    top: 1150 * scale,
                                    left: 2250 * scale,
                                    width: 800 * scale,
                                    height: 700 * scale,
                                    transform: 'rotate(135deg)',
                                }}/>
                                <div
                                    className="group-hover:scale-125 transform-gpu transition duration-300 text-2xl absolute"
                                    style={{
                                        top: 1723 * scale,
                                        left: 2915 * scale,
                                    }} >
                                    <img style={{width: 270 * scale}} src={asset('/images/map/my-profile.png')}/>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.popup && this.renderPopup()}
                {/*{this.renderMobileMenu()}*/}
            </div>
        )
    }

    /**
     * @method renderMobileButton
     * @param {string} display
     * @param {string} to
     * @param {object} icon
     * @param {boolean|string} lockedUntil
     * @return {JSX.Element}
     */
    renderMobileButton = (display, to, icon, lockedUntil = false) => {
        if (lockedUntil) {
            const unlocksAt = DateTime.fromISO(lockedUntil);
            const now = DateTime.now();

            if (unlocksAt > now) {
                return (
                    <div
                        className="text-white my-4 font-proxima-nova md:text-lg uppercase flex items-center opacity-25">
                        <FontAwesomeIcon
                            className="mr-4"
                            icon={icon}
                            fixedWidth={true}
                            size="lg"
                        />

                        {display}
                    </div>
                );
            }
        }

        return (
            <Link
                className="text-white my-4 font-proxima-nova md:text-lg uppercase flex items-center"
                to={to}
            >
                <FontAwesomeIcon
                    className="mr-4"
                    icon={icon}
                    fixedWidth={true}
                    size="lg"
                />

                {display}
            </Link>
        );
    };

    renderPopup = () => {
        return (
            <div className="fixed flex inset-0 w-full h-full">
                <div className="w-full h-full absolute" onMouseDown={() => this.setState({popup: null})}/>
                <div className="m-auto w-96 bg-app-gray text-black p-3 rounded-md z-10 relative">
                    <FontAwesomeIcon color="black" icon={faTimes} className="absolute top-3 right-3 cursor-pointer"
                                     onClick={() => this.setState({popup: null})}/>

                    <div className="text-2xl mb-2 text-center font-canela">
                        {this.popup[this.state.popup ?? 'main_stage'].title}
                    </div>
                    <div className="mb-3 text-center">
                        {this.popup[this.state.popup ?? 'main_stage'].description ?? 'This area will be accessible on Wednesday 2nd November.'}
                    </div>
                    {/*<div className="flex">*/}
                    {/*    <Link className="rounded-md bg-app-teal-dark hover:bg-opacity-40 px-3 py-2 mx-auto"*/}
                    {/*          to={this.popup[this.state.popup ?? 'main_stage'].link}>Continue</Link>*/}
                    {/*</div>*/}
                </div>
            </div>
        );
    };
}
